import { useState } from 'react';
import { Form, Button, Collapse } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import '../App.css';
import vancura from '../assets/vancura.png'
import Exercise from '../exercise/Exercise'
import {useParams} from "react-router-dom";



function ExercisePage() {
    const {id} = useParams()
  return (
    <div>
      <Exercise 
        id={id}
      />
    </div>
  );
}

export default ExercisePage;
